const COLOR_TOKENS = [
    'white',
    'black',
    'natural',
    'clear',
    'transparent',
    'red',
    'blue',
    'green',
    'yellow',
    'gray',
    'grey',
    'orange',
    'purple',
    'brown',
    'pink',
    'tan',
    'ivory',
    'beige',
    'gold',
    'silver',
    'bronze',
];
const COLOR_NAME_PATTERN = new RegExp(`\\b(${COLOR_TOKENS.join('|')})\\b`, 'i');
export const materialNameHasColor = (name) => {
    return COLOR_NAME_PATTERN.test(name.trim());
};
export const isPlasticNeedingColor = (material) => {
    if (!material || material.material_type !== 'Plastic') {
        return false;
    }
    if (material.colored) {
        return false;
    }
    return !materialNameHasColor(material.name || '');
};
